import { FormattedMessage } from 'react-intl';
import './Dashboard.less';
import Title from 'antd/lib/typography/Title';



const Dashboard = () => {
  return (
    <>
      <Title level={3} className='dashboard-title'><FormattedMessage id='DASHBOARD_TITLE' /></Title>
    </>
  );
}

export default Dashboard;